import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

type NodeEnv = "production" | "development" | "testing";

const getGaMeasurementId = (): string | null => {
  const deployTarget: NodeEnv = import.meta.env.VITE_DEPLOY_TARGET as NodeEnv;

  if (deployTarget === "testing") {
    return "G-W1CERKFR5M";
  }

  if (deployTarget === "production") {
    return "G-KJHEY94D8N";
  }

  return null;
};

export const GoogleAnalytics4 = () => {
  const location = useLocation();

  useEffect(() => {
    const gaMeasurementId = getGaMeasurementId();
    if (!gaMeasurementId) {
      return;
    }

    ReactGA.initialize(gaMeasurementId, {
      legacyDimensionMetric: false,
    });

    const send = () => {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname,
      });
    };
    setTimeout(send, 1000);
  }, [location]);

  return null;
};
